import React, {useState} from 'react';
import { useEffect } from 'react';
import AirconMode from '../../../assets/img/dashboard/airconMode';
import FanMode from '../../../assets/img/dashboard/fanMode';
import AirConIcon from '../../../assets/img/dashboard/iconAircon';
import PowerIcon from '../../../assets/img/dashboard/powerLarge';

const AirConditionType = ({selectedItem, handlePostData, action}) => {
	const [power, setPower] = useState(selectedItem.deviceState.power === "꺼짐" || !selectedItem.deviceState.power ? false : true)
	const [temperature, setTemperture] = useState(Number(selectedItem.deviceState.temperature) ? Number(selectedItem.deviceState.temperature) : 0);
	const [mode, setMode] = useState(selectedItem.deviceState.mode ? Number(selectedItem.deviceState.mode) : 0);
	const [fanSpeed, setFanSpeed] = useState(selectedItem.deviceState.fanSpeed ? Number(selectedItem.deviceState.fanSpeed) : 0);
	useEffect(()=>{},[mode, fanSpeed, temperature, power])

	const handleMode = () => {
		
		setMode(prevMode => prevMode === 4 ? 0 : prevMode + 1 );
		handlePostData('mode', mode === 4 ? '0' : (mode + 1).toString());
		action();
	}
	const handleFanSpeed = () => {
		setFanSpeed(prevFanspeed => prevFanspeed === 3 ? 0 : prevFanspeed + 1 )
		handlePostData('fanSpeed', fanSpeed === 3 ? '0' : (fanSpeed + 1).toString());
		action();
	}

	const handleTempPlus = () => {
		setTemperture(prevTemp => prevTemp < 30 ? Number(prevTemp) + 1 : prevTemp )
		setTimeout(()=>{
			if(temperature < 30) handlePostData('temperature', Number(temperature + 1));
		},100)
		action();
}
	const handleTempMinus = () => {
		setTemperture(prevTemp => prevTemp > 16 ? Number(prevTemp) - 1 : prevTemp );
		setTimeout(()=>{
			if(temperature > 16) handlePostData('temperature', Number(temperature - 1));
		},100)
		action();
	}
	const handleAirconPower = () => {
		handlePostData('power', !power);
		setPower(!power);
		action();
	}
	return (
		<>
		<section className={!power ? "device-setting-body off": "device-setting-body"}>
			<div className="device-display aircondition">
				<div className="display">
					{!power ? <h3>-</h3> : <h3>{temperature}&#8451;</h3>}
					
					<p>희망 온도</p>
				</div>
				<section className="menu">
					<h4>모드</h4>
					<ul>
						<li className={mode === 0 ? "active" :""}>냉방</li>
						<li className={mode === 1 ? "active" :""}>난방</li>
						<li className={mode === 2 ? "active" :""}>자동</li>
						<li className={mode === 3 ? "active" :""}>송풍</li>
						<li className={mode === 4 ? "active" :""}>제습</li>
					</ul>
				</section>
				<section className="menu">
					<h4>풍속</h4>
					<ul>
						<li className={fanSpeed === 1 ? "active" :""}>낮음</li>
						<li className={fanSpeed === 2 ? "active" :""}>중간</li>
						<li className={fanSpeed === 3 ? "active" :""}>높음</li>
						<li className={fanSpeed === 0 ? "active" :""}>자동</li>
					</ul>
				</section>
			</div>

			<div className="device-control-wrap">
				<div className="device-control device-control-flex">
					<p className="aircon-button" onClick={power ? handleMode : undefined}>
						<span><AirconMode mode={mode}/></span>
						<span>모드</span>
					</p>
					<p className="aircon-button" onClick={power ? handleFanSpeed : undefined}>
						<span><FanMode fanspeed={fanSpeed}/></span>
						<span>풍속</span>
					</p>
					<p className="aircon-buttons">
						<span>
							<button onClick={power ? handleTempMinus : undefined}>
								<AirConIcon type="down"/>
							</button>
							<button onClick={power ? handleTempPlus : undefined}>
								<AirConIcon type="up" />
							</button>
						</span>
						<span>온도</span>
					</p>
				</div>
			</div>
		</section>
		<section className="device-setting-footer">
			<div className="device-button">
				<button onClick={handleAirconPower}>
					<PowerIcon/> 전원
				</button>
			</div>
		</section>
		</>
	);
}

export default AirConditionType;